export default {
  namespaced: true,
  state: {
    form: {
      contactType: 1,
      corpName: '',
      responsibleName: '',
      mailAddress: '',
      tel: '',
      comment: '',
      deptName: '',
      responsibleTel: '',
      postCd: '',
      prefectureCd: '1',
      address2: '',
      address3: '',
      faxNo: '',
      introducerHonorificsName: '',
      tmpStr: null,
      entryPlanId: '',
      usagePlanId: '',
    },
    isSupple: false,
  },
  mutations: {
    SET_IS_SUPPLE(state, payload) {
      state.isSupple = payload;
    },
    SET_FORM(state, payload) {
      state.form = payload;
    },
    INIT(state) {
      state.form = {
        contactType: 1,
        corpName: '',
        responsibleName: '',
        mailAddress: '',
        tel: '',
        comment: '',
        deptName: '',
        responsibleTel: '',
        postCd: '',
        prefectureCd: '1',
        address2: '',
        address3: '',
        faxNo: '',
        introducerHonorificsName: '',
        tmpStr: null,
        entryPlanId: '',
        usagePlanId: '',
      };
    }
  },
  getters: {
    getForm(state) {
      return state.form;
    },
    getIsSupple(state) {
      return state.isSupple;
    },
  },
  actions: {
    setForm({commit}, payload) {
      commit('SET_FORM', payload);
    },
    init({commit}) {
      commit('INIT');
    },
    setIsSupple({commit}, payload) {
      commit('SET_IS_SUPPLE', payload);
    }
  }
}